import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useT } from "../../shared/i18n";
import { RotateRightIcon } from "../../shared/components/icons";
import { DeleteSweepIcon } from "../../shared/components/icons";
import { CloseIcon } from "../../shared/components/icons";

/** Sticky bulk-edit bar shown once items are selected in bulk mode. */
export function BulkActionBar({
  count,
  refreshing,
  onRefresh,
  onDelete,
  onClear,
}: {
  count: number;
  refreshing: boolean;
  onRefresh: () => void;
  onDelete: () => void;
  onClear: () => void;
}) {
  const t = useT();
  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="center"
      sx={{
        position: "sticky",
        bottom: 0,
        p: 1,
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
      }}
    >
      <Button
        variant="outlined"
        startIcon={<RotateRightIcon />}
        onClick={onRefresh}
        disabled={refreshing}
        size="small"
      >
        {t("bulkRefresh", { count: String(Math.min(count, 10)) })}
      </Button>
      <Button
        variant="outlined"
        color="error"
        startIcon={<DeleteSweepIcon />}
        onClick={onDelete}
        size="small"
      >
        {t("bulkDelete", { count: String(count) })}
      </Button>
      <Button variant="outlined" onClick={onClear} size="small">
        <CloseIcon />
      </Button>
    </Stack>
  );
}